

















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import BaseButton from '@/components/Rain/Buttons/BaseButton.vue'
import { Action, Getter } from "vuex-class"
import { EngagementQuestionIcon } from "@/mobile/src/components/engagement/utils"

@Component<EngagementBanner>({
    components: {BaseButton}
})
export default class EngagementBanner extends Vue {
    @Getter private hasUnopenedEngagementQuestions!: boolean
    @Getter private hasUnansweredQuestions!: boolean

    @Getter
    public dailyEngagementQuestionToShow

    @Action
    public setEngagementModalOpened

    get shouldShowBanner() {
        // Display banner only when the user has opened the question but hasn't answered
        return !this.hasUnopenedEngagementQuestions && this.hasUnansweredQuestions
    }

    get icon() {
        return EngagementQuestionIcon[this.dailyEngagementQuestionToShow.theme]
    }

    get isMobile() {
        return process.env.CONFIG_KEY === 'mobile'
    }

    onClickBanner(mobileOnly: boolean) {
        if (mobileOnly && !this.isMobile) {
            return
        }
        this.setEngagementModalOpened(true)
    }
}
